import "./Sidebar.scss";
import { HomeIcon, FavoriteIcon, UserIcon } from "../../assets/icons";
import { ProIcon, SpotifyIcon } from "../../assets/images";
import { Link, NavLink } from "react-router-dom";
import Playlist from "../Music/Playlist/Playlist";
import { useSelector, useDispatch } from "react-redux";
import useFirestore from "../../hooks/useFirestore";
import { setPlaylists } from "../../store/actions/musicActions";
import Spinner from "../UI/Spinner/Spinner";
import { useEffect, useState } from "react";
import { openInfo, toggleSidebar } from "../../store/actions/infoActions";

const Sidebar = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { docs } = useFirestore("playlists");
  const playlists = useSelector((state) => state.music.playlists);
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.info.isSidebarOpen);

  useEffect(() => {
    dispatch(setPlaylists(docs));
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [docs, dispatch]);

  return (
    <>
      {isSidebarOpen && (
        <div
          className="sidebar__backdrop"
          onClick={() => dispatch(toggleSidebar())}
        ></div>
      )}
      <div className={`sidebar ${isSidebarOpen && "open"}`}>
        <Link to="/">
          <h1 className="sidebar__title">
            <SpotifyIcon />
            <span>
              Spotify <small className="clone">clone</small>
            </span>
          </h1>
        </Link>

        <nav className="sidebar__links">
          <NavLink exact to="/" className="sidebar__links--item">
            <HomeIcon />
            <span>Home</span>
          </NavLink>

          <NavLink to="/favorites" className="sidebar__links--item">
            <FavoriteIcon />
            <span>Favorites</span>
          </NavLink>

          <NavLink to="/user" className="sidebar__links--item">
            <UserIcon />
            <span>User</span>
          </NavLink>
        </nav>

        <div className="sidebar__playlists">
          <h4>PLAYLISTS</h4>
          {isLoading && <Spinner />}
          {playlists?.map((playlist) => (
            <Playlist key={playlist.id} title={playlist.title} />
          ))}
        </div>

        <div className="sidebar__info">
          <ProIcon />
          <button
            className="sidebar__info--btn"
            onClick={() => dispatch(openInfo())}
          >
            APP INFO
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
